import { Label } from "@exopengithub/exokit";
import { useTranslation } from "react-i18next";

import { DeleteCompanyDomainDialog } from "./DeleteCompanyDomainDialog.tsx";
import { Card } from "../planning/components/Card.tsx";

import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.ts";

export const CompanyDomainSettingsPage = () => {
	const { t } = useTranslation();
	const companyDomain = useLoadedCompanyDomain();

	return (
		<div className="space-y-4">
			<Card>
				<div className="p-4">
					<div className="mb-2 font-bold text-lg">{t("General")}</div>
					<Label>{t("Company domain name")}</Label>
					<div className="text-sm text-grey-900">{companyDomain.name}</div>
				</div>
			</Card>

			<Card>
				<div className="p-4">
					<div className="mb-2 font-bold text-lg">
						{t("Delete company domain")}
					</div>
					<div className="mb-2">
						{t(
							"Permanently remove your company domain and all of its contents from Exopen. This action is not reversible — please continue with caution.",
						)}
					</div>
					<div className="flex justify-end">
						<DeleteCompanyDomainDialog />
					</div>
				</div>
			</Card>
		</div>
	);
};
